import { get, post, postFormData, dlt } from './Api';

const endpoint = 'wip-panels/ad-hoc-request';

export const getById = async (id) => await get(`${endpoint}/${id}`);
export const read = async (data) => await post(`${endpoint}/read`, data);
export const readList = async (data) => await post(`${endpoint}/read/list`, data);
export const create = async (data) => await postFormData(`${endpoint}`, data);
export const update = async (data) => await postFormData(`${endpoint}/update`, data);
export const deleteRequest = async (id) => await dlt(`${endpoint}/${id}`);
export const issueRequest = async (id) => await get(`${endpoint}/issue/${id}`);
export const undoIssueRequest = async (id) => await dlt(`${endpoint}/undo-issue/${id}`);
